import React from 'react';
import { Skeleton } from '@vtblife/uikit';

import classname from '@search/classname/src';

import './style.css';

const cn = classname.bind(null, 'BanksMortgageOffers');

export const MortgageOfferSkeleton = () => {
    return (
        <div className={cn()}>
            <div className={cn('offer')}>
                <div className={cn('img-loader')}>
                    <Skeleton />
                </div>
            </div>
            <div className={cn('offer-info')}>
                <span className={cn('percent-loader')}>
                    <Skeleton />
                </span>
                <span className={cn('payment-loader')}>
                    <Skeleton />
                </span>
            </div>
        </div>
    );
};
